export default __webpack_public_path__ + "static/media/series.460f706b.svg";